import Base from "./Base";

/**
 * @class MatchingBase
 */
export default class MatchingBase extends Base {
    /**
     * @param {Number}  id
     * @param {String}  name
     * @param {String}  displayName
     * @param {Number}  density
     * @param {Number}  baseInProductId
     * @param {Array}   colorantList
     * @param {Array}   packageList
     */
    constructor(id, name, displayName, density = 0, baseInProductId = null, colorantList = []) {
        super(id, name, displayName, density);

        this._baseInProductId = baseInProductId;
        this._colorantList = colorantList;
        this._packageList = [];
    }

    /**
     * @return {Array}
     */
    get colorantList() {
        return this._colorantList;
    }

    /**
     * @param {Array} colorantList
     */
    set colorantList(colorantList) {
        this._colorantList = colorantList;
    }

    /**
     * @return {Array}
     */
    get packageList() {
        return this._packageList;
    }

    /**
     * @param {Array} packageList
     */
    set packageList(packageList) {
        this._packageList = packageList;
    }

    /**
     * @return {Object}
     */
    clone() {
        return new MatchingBase(
            this._id,
            this._name,
            this._displayName,
            this._density,
            this._baseInProductId,
            this._colorantList,
            this._packageList
        );
    }

    /**
     * Clones matching base object and updates package list property.
     *
     * @param   {packageList}   packageList
     * @return  {Object}
     */
    updatePackageList = (packageList) => {
        let newMatchingBase = this.clone();
        newMatchingBase.packageList = packageList;

        return newMatchingBase;
    };
}
